module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-two-squares-1bbf8c83.svg";